import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  private jsonContent = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  constructor(private http: HttpClient,
    private configService: ConfigService) { }

  public login(login: any): Promise<any> {
    const body = JSON.stringify(login);
    return this.http.post(
      `${this.configService.PUB_URL}/authentication/user`,
      body,
      { ...this.jsonContent, responseType: 'text' }).toPromise();
  }

  public obtenerMenuUsuario(): Promise<any>{
    let headerContent =  {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'User': sessionStorage.getItem('userid') != null ? sessionStorage.getItem('userid') : '0' 
      })
    };
    return this.http.get(
      `${this.configService.PUB_URL}/menu/user`,
      { ...headerContent, responseType: 'json' },
    ).toPromise();
  }

  public obtenerPermisosMenu(menu:string): Promise<any> {
    let headerContent =  {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'User': sessionStorage.getItem('userid') != null ? sessionStorage.getItem('userid') : '0' 
      })
    };
    return this.http.get(
      `${this.configService.PUB_URL}/menu/user/${menu}/permisos`,
      { ...headerContent, responseType: 'json' },
    ).toPromise();
  }

  public getkeyWord(): Promise<any> {
    let headerContent =  {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    return this.http.get(
      `${this.configService.PUB_URL}/access/validation`,
      { ...headerContent, responseType: 'json' },
    ).toPromise();
  }



}
